/* eslint-disable import/no-anonymous-default-export */
import { AutoComplete, Button, Collapse, DatePicker, Form, Input, InputNumber, Select, Space } from "antd";
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import TextArea from "antd/lib/input/TextArea";
import { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import DataSave, { DataSaveRef } from "../common/components/DataSave";
import MainLayout from "../common/components/MainLayout";
import useCategorias from "./hooks/useCategorias";
import useCodigosInfraccionAPI, { CodigoInfraccion, CodigoInfraccionForm, CodigoInfraccionSave } from "./hooks/useCodigosInfraccionAPI";
import useEtiquetas from "./hooks/useEtiquetas";
import styled from "styled-components";
import _, { size } from 'lodash';
import moment from "moment";
import 'moment/locale/es-mx';
import locale from 'antd/es/date-picker/locale/es_ES'
import TagInput from "../common/components/TagInput";
import useUtils from "../common/hooks/useUtils";

moment.updateLocale('es-mx', {
    week: {
        dow: 1
    },

});


const SegmentoUf = styled.div`
display: flex;
gap:0.5rem;
align-items: center;
& button
{
    margin-top: 5px;
}
`;

const SegmentoFecha = styled.div``;

export default () => {
    const { id } = useParams();
    const {getProvinciasList} = useUtils();
    const ref = useRef<DataSaveRef<Partial<CodigoInfraccionForm>>>(undefined!);
    const api = useCodigosInfraccionAPI();
    const successRoute = "/codigos-infraccion"
    const { categorias } = useCategorias();
    const { etiquetas } = useEtiquetas();
    const [data, setData] = useState<Partial<CodigoInfraccionForm>>({
        SegmentosUf: [{}]
    });

    const addSegmentoUf = (LimiteFecha?: moment.Moment) => {
        const newData = {
            ...data,
            ...{
                SegmentosUf: [...data.SegmentosUf!, ...[{ LimiteFecha }]]
            }
        };

        ref.current.form.setFieldsValue(newData);
        setData(newData);
    }

    const removeSegmentoUf = (index: number) => {
        const newSegmentosUf = [...data.SegmentosUf!];
        newSegmentosUf.splice(index, 1);
        const newData = {
            ...data,
            ...{
                SegmentosUf: newSegmentosUf
            }
        };

        ref.current.form.setFieldsValue(newData);
        setData(newData)
    };

   
    const segmentosFecha = _.memoize(() => {
        const segmentos = data?.SegmentosUf?.map((s, index) => ({ ...s, ...{ id: index, LimiteFecha: moment(s.LimiteFecha).year() == 0 ? undefined : s.LimiteFecha } })) ?? [];
        const map = _.chain(segmentos)
            .orderBy(s => s.LimiteFecha, 'asc')
            .groupBy(s => s.LimiteFecha)
            .mapValues(s => _.orderBy(s, (value) => value.LimiteMedicion, 'asc'))
            ;

        return Object.values(map.value());
    });

    return (
        <MainLayout title="Guardar código de infracción">
            <DataSave<CodigoInfraccion, CodigoInfraccionSave, Partial<CodigoInfraccionForm>>
                list={(query) => api.list({ ...query, ...{ $expand: ['SegmentosUf', 'EtiquetasImagenes'] } })}
                save={api.save}
                transformOnLoad={async (value) => ({ ...value, ...{ SegmentosUf: value.SegmentosUf.length > 0 ? value.SegmentosUf.map((s) => ({ ...s, ...{ LimiteFecha: moment(s.LimiteFecha).year() > 0 ? moment(s.LimiteFecha) : undefined } })) : [{}] } })}
                transformOnSave={async (value) => ({ ...(value as CodigoInfraccion), ...{ SegmentosUf: JSON.stringify(value.SegmentosUf), EtiquetasImagenes: JSON.stringify(value.EtiquetasImagenes) } })}
                id={id}
                ref={ref}
                successRoute={successRoute}
                onLoadedItem={async (item) => setData({ ...item, ...{ SegmentosUf: item.SegmentosUf.map((s) => ({ ...s, ...{ LimiteFecha: moment(s.LimiteFecha).year() > 0 ? moment(s.LimiteFecha) : undefined } })) } })}
                onChange={(data) => setData(data)}
            >
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Codigo"}
                    label="Código">
                    <Space>
                        <Input size = "middle"/>
                    </Space>
                </Form.Item>

                <Form.Item
                    name={"Articulo"}
                    label="Artículo">
                    <Input />
                </Form.Item>

                <Form.Item
                    name={"Inciso"}
                    label="Inciso">
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Descripcion"}
                    label="Descripcion">
                    <TextArea />
                </Form.Item>

                <Collapse style={{ marginBottom: 10 }} >
                    {segmentosFecha().map((segmentos, i) =>
                        <Collapse.Panel
                            forceRender
                            key={i}
                            header={!segmentos[0]!.LimiteFecha ? 'Segmentos UF finales' : `Segmentos UF hasta el ${moment(segmentos[0]!.LimiteFecha).format('DD/MM/YYYY')}`}>
                            <SegmentoFecha>
                                {segmentos.map((segmento, j) =>
                                    <SegmentoUf key={`segmento-${segmento.id}`}>
                                        <strong>Segmento {j + 1}</strong>
                                        <Form.Item
                                            label="Valor de la infracción (UF)"
                                            rules={[
                                                { required: true, message: "Campo requerido" },
                                                { min: 1, type: "number", message: "Ingrese un número mayor a 0" }
                                            ]}
                                            required
                                            name={['SegmentosUf', segmento.id, 'ValorUf']}
                                        >
                                            <InputNumber style={{ width: "auto" }} min={1} />
                                        </Form.Item>
                                        {segmentosFecha()[i].length - 1 != j &&
                                        <Form.Item
                                        label="Valor medido máximo"
                                        rules={[
                                            { min: 1, type: "number", message: "Ingrese un número mayor a 0" },
                                            { required: segmento.Provincia == undefined, message: "Camporequerido" },
                                            ]}
                                        required={segmento.Provincia == undefined}
                                        name={["SegmentosUf", segmento.id, "LimiteMedicion"]}
                                        >
                                        <InputNumber style={{ width: "auto" }} />
                                        </Form.Item>
                                        }
                                        {(segmentosFecha().length - 1 != i || segmentosFecha()[i].length - 1 != j) && <Form.Item
                                            label={"Fecha límite"}
                                            name={['SegmentosUf', segmento.id, 'LimiteFecha']}
                                            rules={[
                                                { required: segmentosFecha().length - 1 != i, message: "Campo requerido" },
                                            ]}
                                            required={segmentosFecha().length - 1 != i}
                                            normalize={(value: moment.Moment, prevValue, allValues) => value ? value.set({ hour: 23, minute: 59, seconds: 59 }) : undefined}
                                        >
                                            <DatePicker format={"DD-MM-YYYY"} locale={locale} placeholder="Seleccione una fecha..." />
                                        </Form.Item>}

                                        {segmentosFecha()[i].length - 1 != j && (
                                    <>
                                        <Form.Item
                                        label="Prov. (Titular)"
                                        rules={[
                                            {
                                                required: segmento.CodigoPostal != undefined && segmento.CodigoPostal != "",
                                                message: "Campo requerido",
                                            },
                                            ]}
                                        required={segmento.CodigoPostal != undefined && segmento.CodigoPostal != "" }
                                        name={["SegmentosUf", segmento.id, "Provincia"]}
                                        >
                                        <Select showSearch allowClear style={{ width: "130px" }}>
                                                {getProvinciasList().map((province : any,index) => (
                                            <Select.Option key={index} value={province}>
                                                {province}
                                            </Select.Option>
                                            ))}
                                        </Select>
                                        </Form.Item>  

                                        <Form.Item
                                        label="C.P (Titular)"
                                        name={["SegmentosUf", segmento.id, "CodigoPostal"]}
                                        >
                                        <Input style={{ width: "70px" }} />
                                        </Form.Item> 
                                    </>
                                 )} 

                                        <Button type="primary" onClick={() => addSegmentoUf(segmento.LimiteFecha)} icon={<PlusOutlined />} />
                                        <Button type="primary" onClick={() => removeSegmentoUf(segmento.id)} icon={<MinusOutlined />} />
                                    </SegmentoUf>)}
                            </SegmentoFecha>
                        </Collapse.Panel>
                    )}
                </Collapse>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" },
                        { min: 1, type: "integer", message: "Ingrese un entero mayor a 0" }
                    ]}
                    required
                    name={"ValorUfMax"}
                    label="Valor máximo de la multa en UF">
                    <InputNumber />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" },
                        { min: 1, type: "integer", message: "Ingrese un entero mayor a 0" }
                    ]}
                    required
                    name={"ValorUfMin"}
                    label="Valor mínimo de la multa en UF">
                    <InputNumber />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Categoria"}
                    label="Categoría">
                    <AutoComplete
                        allowClear
                        filterOption
                        options={categorias}
                    />
                </Form.Item>

                <Form.Item
                    rules={[
                        { min: 1, type: "integer", message: "Ingrese un entero mayor a 0" }
                    ]}
                    name={"PuntosRestados"}
                    label="Puntos restados">
                    <InputNumber />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    help="Utilizada para asociar los códigos a unidades de producción. Ej: CUI Misiones"
                    name={"Etiqueta"}
                    label="Etiqueta">
                    <AutoComplete
                        allowClear
                        filterOption
                        options={etiquetas}
                    />
                </Form.Item>

                <Form.Item
                    help="Utilizada para mostrar en el acta. Si no se especifíca, se utiliza la descripción"
                    name={"Abreviatura"}
                    label="Abreviatura">
                    <Input />
                </Form.Item>

                <Form.Item
                    help="Utilizado para asociar a una infracción, cuando esta ya viene renombrada y con un tipo de infracción predefinido, Ej: 100 = 'Luces bajas'"
                    name={"Identificador"}
                    label="Identificador">
                    <Input />
                </Form.Item>

                <Form.Item
                    name={"Observaciones"}
                    label="Observaciones">
                    <TextArea />
                </Form.Item>

                <Form.Item
                    label="Etiquetas de imagen"
                    name="EtiquetasImagenes"
                >
                    <TagInput />
                </Form.Item>



            </DataSave>
        </MainLayout>
    );
};

